import { QueryClientConfig } from '@tanstack/react-query';

// import alertFromApiResponse, { genericNetworkError } from './alertFromApiResponse';

const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 3, // 3 minutes
      refetchOnWindowFocus: false,
      retry: false,
      throwOnError: (_error, _query) => {
        return true;
      }
    }
    // mutations: {
    //   throwOnError: error => {
    //     if ((error as AxiosError).response?.status === 422) {
    //       // toast.error(genericNetworkError);
    //       return false;
    //     }

    //     return true;
    //   }
    // }
  }
};

export default queryClientConfig;
